import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { Vehicle } from "@/app/services/generated/vehicleService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import { vehicleService } from "@/app/services/extensions/vehicleServiceExtended";
import type Guid from "@/app/types/common/guid";
import { GuidMap } from "@/app/types/common/guidcollections";
import type { Maybe } from "@/components/utils/typeHelpers";

export interface IHasVehiclesCache {
  vehicles: VehiclesCache;
}

// Singleton cache store
const vehiclesCacheStore = new EntityCacheStore<Vehicle>(
  EnumCacheEntityType.vehicle,
  async () => vehicleService.getAllVehicles()
);

// Ephemeral reader
export default class VehiclesCache extends EntityWithGuidKeyCache<Vehicle> {
  private _displayColourMap = new GuidMap<string>();

  constructor() {
    super(vehiclesCacheStore, (x) => x.id);
  }

  async update() {
    await super.update();
    this._displayColourMap = vehicleService.getVehicleDisplayColourMap(
      this.all
    );
  }

  getDisplayColour(vehicleId: Maybe<Guid>): string {
    return this._displayColourMap.get(vehicleId) ?? "";
  }
}
